import type { App } from "vue";
import { defineAsyncComponent } from 'vue';
import { setupCalendar, Calendar, DatePicker } from 'v-calendar';

// Sidebar components are lazy-loaded — only the one matching the current route
// sidebar meta value is ever parsed and mounted.
const KTSidebarGeneral = defineAsyncComponent(() => import("@/layout/sidebar/SidebarGeneral.vue"))
const KTSidebarCalendar = defineAsyncComponent(() => import("@/layout/sidebar/SidebarCalendar.vue"))
const KTSidebarCheckin = defineAsyncComponent(() => import("@/layout/sidebar/SidebarCheckin.vue"))
const KTSidebarShop = defineAsyncComponent(() => import("@/layout/sidebar/SidebarShop.vue"))
const KTSidebarUser = defineAsyncComponent(() => import("@/layout/sidebar/SidebarUser.vue"))
const KTSidebarCommunication = defineAsyncComponent(() => import("@/layout/sidebar/SidebarCommunication.vue"))

export function createGlobalComponents(app: App<Element>) {
  app.component("kt-sidebar-general", KTSidebarGeneral);
  app.component("kt-sidebar-calendar", KTSidebarCalendar);
  app.component("kt-sidebar-checkin", KTSidebarCheckin);
  app.component("kt-sidebar-shop", KTSidebarShop);
  app.component("kt-sidebar-user", KTSidebarUser);
  app.component("kt-sidebar-communication", KTSidebarCommunication);
  // external components
  app.use(setupCalendar, {
    firstDayOfWeek: 1,
    formats: {
      title: 'MMMM YYYY',
      weekdays: 'W',
      navMonths: 'MMM',
      input: ['L', 'DD.MM.YYYY'],
      dayPopover: 'L'
    },
    weeks: true,
    paneWidth: 250
  } as any)
  app.component('VCalendar', Calendar)
  app.component('VDatePicker', DatePicker)
}
